export const WHATS_INCLUDED = {
  TENANTS_LIABILITY: [
    "Protection from costs incurred from accidental damage caused to your landlord’s property that you’re legally responsible for, such as fixtures and fittings or furniture where provided. You must report each claim as soon as possible and no later than 60 days after the event has occurred.",
    "Up to £100,000 for legal costs in pursuing and defending personal claims, such as tenancy disputes with the landlord, unlawful eviction, employment disputes and bodily injury claims.",
    "If you have a claim value under £400 your excess will be £0. If you have a claim value of £400 or above your excess will be £50. Any claims for pet damage an excess of £75 will apply.",
  ],
  TENANTS_CONTENTS: [
    "Accidental damage cover for TVs and audio visual equipment included as standard",
    "Cover for life-impacting damage such as water leaks, sewage blockages and more",
    "Alternative accommodation for you and any pets living with you",
    "Tenant's liability cover included as standard",
  ],
  RENT_PROTECTION: [
    "Cover for rent arrears (up to a maximum value per month) for up to 12 months",
    "24-hour legal advice helpline for queries relating to the letting of the property",
    "Tenant mediation services",
  ],
  MPPI: [
    "Mortgage repayments and other household costs, up to £3,000 or 75% of your gross monthly income (whichever is lower). You also choose a qualification period - this is how long you are not able to work or out of work before we will start paying a claim.",
    "Flexible terms - cover for up to 12 or 24 months, allowing you to focus on getting back on your feet.",
    "Dedicated customer support should you need to make a claim.",
  ],
};
